import React from "react";
import { AnnouncementInboxHost } from "../Announcement/AnnouncementInbox";
import SessionExpiryHost from "./SessionExpiryHost";

/**
 * Overlays and watchers that must stay mounted across authenticated routes.
 * Lives inside BrowserRouter (needs useLocation) but outside Routes so navigation
 * does not unmount them — same pattern as the announcement inbox before this file existed.
 */
const AppGlobalHosts = () => (
  <>
    <AnnouncementInboxHost />
    <SessionExpiryHost />
  </>
);

export default AppGlobalHosts;
